import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {PENDING_RETURN_ACTION_IDS} from '@/consts/pendingReturnActionIds';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import usePendingReturnActionRedirect from '@/hooks/usePendingReturnActionRedirect';
import type {BannerModel} from '@/types/aem/bannerModel';

import AutoDeliveryDcxWidgetContainer from './AutoDeliveryDcxWidgetContainer';
import AutoDeliveryDcxWidgetHeader from './AutoDeliveryDcxWidgetHeader';

interface AutoDeliveryDcxInactiveBannerWidgetProps {
    className?: string;
    banner?: BannerModel;
}

const AutoDeliveryDcxInactiveBannerWidget = ({className, banner}: AutoDeliveryDcxInactiveBannerWidgetProps) => {
    const {title, description, icon, button} = banner || {};
    const {redirectToExternalLink} = useConfigExternalLink(button?.externalLink);
    const onClick = usePendingReturnActionRedirect(
        PENDING_RETURN_ACTION_IDS.AUTO_DELIVERY_DETAILS,
        redirectToExternalLink
    );

    if (!banner) return null;

    return (
        <AutoDeliveryDcxWidgetContainer className={className}>
            <AutoDeliveryDcxWidgetHeader showManageButton={false} showPastOrdersButton />
            <AutoDeliveryDcxWidgetContainer.ContentContainer className='md:mt-8'>
                <div className='flex flex-col rounded-xl bg-primary-dark-5 p-4 text-center text-primary-dark md:bg-romance md:px-6 md:py-8'>
                    <div className='flex flex-col items-center justify-center gap-2'>
                        <RemoteIconV2 className='size-12' icon={icon} />
                        <h3 className='text-20 font-bold leading-[28px] tracking-02'>{title}</h3>
                        <p className='text-14 leading-[20px] tracking-04'>{description}</p>
                    </div>
                    {button && redirectToExternalLink && (
                        <AppButton
                            aria-label={button?.alt}
                            onClick={onClick}
                            primary
                            light
                            className='m-0 mt-8 md:mt-4 md:w-fit md:self-center'
                        >
                            {button.text}
                        </AppButton>
                    )}
                </div>
            </AutoDeliveryDcxWidgetContainer.ContentContainer>
        </AutoDeliveryDcxWidgetContainer>
    );
};

export default AutoDeliveryDcxInactiveBannerWidget;
